<template>
  <AcademicCardsChapter
    page-title="研究中心活动"
    section-label="学科建设"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :sections="sections"
  />
</template>

<script>
import AcademicCardsChapter from '@/components/AcademicCardsChapter.vue';

export default {
  name: 'Lanhuyanjiuzhongxin',
  components: {
    AcademicCardsChapter
  },
  data() {
    return {
      sectionRoute: '/lanhu_xuekeyukeyan',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      sections: [
        {
          title: '研究中心与实验室活动',
          summary: '研究中心围绕青少年发展、传媒转型、国际传播和影视文化等主题持续组织工作坊、报告发布与论坛沙龙。',
          columns: 2,
          cards: [
            {
              title: '2015 年媒介传播与青少年发展研究中心工作坊',
              src: require('./assets/html/center-2015-workshop.jpg'),
              description: '2015 年 1 月，媒介传播与青少年发展研究中心举办工作坊。'
            },
            {
              title: '2014 年传媒发展研究中心专业建设研讨会',
              src: require('./assets/html/center-2014-media-development.jpg'),
              description: '2014 年，传媒发展研究中心举办“高校网络与新媒体专业建设研讨会”。'
            },
            {
              title: '2018 年世界传媒研究中心影像盛典',
              src: require('./assets/html/center-2018-poverty-image.jpg'),
              description: '2018 年 5 月，世界传媒研究中心举办“中国梦·扶贫攻坚影像盛典”。'
            },
            {
              title: '2017 年传媒调查中心国际传播报告',
              src: require('./assets/html/center-2017-belt-road.jpg'),
              description: '2017 年 6 月，传媒调查中心发表“一带一路”国际传播报告。'
            },
            {
              title: '2016 年全球影视与文化软实力实验室沙龙',
              src: require('./assets/html/center-2016-softpower.jpg'),
              description: '2016 年 10 月，全球影视与文化软实力实验室举办国际研讨沙龙。'
            }
          ]
        }
      ]
    };
  }
};
</script>
